import CustomerLeftSideBar from '../components/navigation/CustomerLeftSideBar'
import CustomerRightSideBar from '../components/navigation/CustomerRightSideBar'

export default function VisualSidebarsPage() {
  return (
    <div className="min-h-screen app-bg text-gray-900 dark:text-gray-100">
      <div className="mx-auto px-3 sm:px-4 lg:px-6 py-8">
        <div className="grid grid-cols-1 md:grid-cols-[1fr_18rem] lg:grid-cols-[18rem_1fr_18rem] gap-4">
          <CustomerLeftSideBar title="Mục lục sản phẩm">
            <div className="space-y-2">
              <div className="text-sm font-semibold">Nhóm 1</div>
              <button type="button" className="w-full text-left px-2 py-2 rounded-xl hover:bg-amber-500/10">
                Sản phẩm A
              </button>
              <button type="button" className="w-full text-left px-2 py-2 rounded-xl hover:bg-amber-500/10">
                Sản phẩm B
              </button>
            </div>
          </CustomerLeftSideBar>

          <main className="min-w-0">
            <div className="card-soft p-6">
              <div className="text-base font-bold">Visual Sandbox</div>
              <div className="text-sm text-slate-600 dark:text-slate-300 mt-1">
                Trang này dùng để chụp screenshot regression cho sidebar trái/phải và theme.
              </div>
            </div>
          </main>

          <CustomerRightSideBar
            activeKey="products"
            onNavigateKey={() => {}}
            onOpenAuth={() => {}}
            mobileOpen={false}
            onCloseMobile={() => {}}
            user={null}
            isInitializing={false}
          />
        </div>
      </div>
    </div>
  )
}

